import images from "./images";

const testimonials = [
  {
    id: 1,
    image: images.testimonial1,
    name: "John Smith",
    title: "Baker",
    content: "This bakery has the finest pastries I've ever tasted. Every bite is fresh and delightful. Their dedication to quality and taste is unmatched. Always my first choice for sweet treats.",
  },
  {
    id: 2,
    image: images.testimonial2,
    name: "Linda Johnson",
    title: "Customer",
    content: "Amazing experience every time. The staff is friendly and helpful, and the baked goods are simply delicious. Online ordering is smooth, and the delivery is always on time.",
  },
  {
    id: 3,
    image: images.testimonial3,
    name: "David Wilson",
    title: "Baker",
    content: "Working with this bakery is a pleasure. We take pride in creating beautiful and tasty products that make customers smile. A truly rewarding experience being part of this team.",
  },
];

export default testimonials;